import type { PropsWithChildren } from 'react';

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { CostSummaryRowStyled } from './styles/CostSummaryRowStyled'
import { CostSummaryStyled } from './styles/CostSummaryStyled'
import { CostSummaryTotalRowStyled } from './styles/CostSummaryTotalRowStyled'

export interface ICostSummaryProps {
  className?: string
  compact?: boolean
  ariaLabel?: string
}

export const CostSummary = ({
  children,
  className,
  compact = false,
  ariaLabel,
}: PropsWithChildren<ICostSummaryProps>) => {
  const intl = useProcurifyIntl()

  return (
    <CostSummaryStyled
      className={className}
      compact={compact}
      aria-label={
        ariaLabel ? ariaLabel : intl.formatMessage(messages.tableAriaLabel)
      }
    >
      <tbody>{children}</tbody>
    </CostSummaryStyled>
  )
}

CostSummary.Cost = CostSummaryRowStyled
CostSummary.Total = CostSummaryTotalRowStyled
